<script setup>
  const config = useRuntimeConfig()

  defineProps({
    ctas: {
      type: Array,
      default: () => []
    }
  })

  const getCtaUrl = (cta) => {
    if (!cta.file?.url) return cta.url
    return `${config.public.strapi}${cta.file.url}`
  }

  const isExternalUrl = (url) => {
    return url?.startsWith('http')
  }
</script>

<template>
  <div v-if="ctas && ctas.length > 0" class="my-8">
    <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
      <NuxtLink
        v-for="cta in ctas"
        :key="cta.id"
        :to="getCtaUrl(cta)"
        :target="isExternalUrl(getCtaUrl(cta)) ? '_blank' : undefined"
        :rel="isExternalUrl(getCtaUrl(cta)) ? 'noopener noreferrer' : undefined"
        class="inline-flex items-center justify-center gap-2 px-6 py-3 text-base font-semibold text-white bg-sky-800 hover:bg-sky-700 rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md"
      >
        <span>{{ cta.title }}</span>
        <font-awesome
          v-if="isExternalUrl(getCtaUrl(cta))"
          class="text-sm"
          :icon="['fas', 'arrow-up-right-from-square']"
        />
        <font-awesome v-else class="text-sm" :icon="['fas', 'arrow-right']" />
      </NuxtLink>
    </div>
  </div>
</template>
